import { BiEvent } from 'analytics';
import { DecodedRouteParams, Route } from 'config/routes';
import { select } from 'redux-saga/effects';
import { routeSelector } from 'store/state/selectors/router';

export const PROF_SYSTEM_EVENT_SOURCES = [
  'professional_neighbourhood_map',
  'professional_city_map',
  'professional_street_map',
];

export function* routeChangePreProcessor(event: BiEvent) {
  const { name, payload } = event;

  const routerState: ReturnType<typeof routeSelector> = yield select(routeSelector);
  const routeParams: DecodedRouteParams = routerState.params || {};
  const shouldIncludeSource = PROF_SYSTEM_EVENT_SOURCES.includes(routeParams.tracking_event_source)
    || (routerState.name === Route.ProjectPage && routeParams.tracking_event_source === 'non_promoted_property_carousel');

  if (name === 'page_view' && shouldIncludeSource) {
    return { ...event, payload: { ...payload, event: { ...payload.event, source: routeParams.tracking_event_source } } };
  }

  return event;
}
